import { useEffect } from "react";
import { connect } from "react-redux";
import { Actions as ACTIONS } from "../../store/actions/permissionActions";
import { permissionOptions } from "./PermissionOptions";
import PermissionsRow from "./permissions/PermissionsRow";
import TopCards from "./permissions/TopCards";
import InviteManagerButton from "./InviteManagerButton";
import { UserMinusIcon } from "@/icons/solid";
import { orderBy } from "lodash";

const PermissionsTable = ({
	permissions,
	getPermissions,
	authorisedUsers,
	getMyPermissions,
	jurisdiction,
	userPermissions,
	accountOwner,
	isDemo,
	openActionOnPermModal,
}) => {
	useEffect(() => {
		if (!permissions) {
			getPermissions();
			getMyPermissions();
		}
	}, []);

	return (
		<div className="col-xl-10 col-lg-12">
			<div
				className="col-12"
				style={{
					overflow: "auto",
					overflowX: "auto",
					flexWrap: "nowrap",
				}}
			>
				<div>
					<div
						className="col-5 pl-0 relative h-[145px]"
						style={{ float: "left", width: "20rem" }}
					>
						{userPermissions != "Read" && (
							<div className="mb-4 absolute bottom-0 left-0">
								<label>Managers</label>
								<div className="btn-group">
									<InviteManagerButton />
									<button
										className="btn btn-default"
										type="button"
										disabled={isDemo}
										onClick={() => {
											openActionOnPermModal("Revoke Access");
										}}
									>
										<UserMinusIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
										<div style={{ float: "left" }}>Revoke</div>
									</button>
								</div>
							</div>
						)}
					</div>
					<div
						style={{
							margin: "auto",
							float: "none",
							overflow: "visible",
							overflowY: "hidden",
						}}
					>
						<div
							style={{
								display: "flex",
								flexWrap: "nowrap",
								paddingLeft: "23px",
								overflow: "hidden",
							}}
						>
							{permissionOptions.map((data) => {
								if (data?.exclude?.includes(jurisdiction)) return;

								return <TopCards key={data.id}>{data.topCard || "Not Available"}</TopCards>;
							})}
						</div>
					</div>
				</div>
				<div className="col-12">
					{authorisedUsers?.map((user, index) => (
						<PermissionsRow
							key={user.id}
							index={index}
							options={permissionOptions}
							user={user}
						/>
					))}
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const authorisedUsers = (state.permissions?.authorisedUsers || []).map((user) => ({
		...user,
		isOwner: user.status === "Owner",
	}));
	const orderedUsers = orderBy(authorisedUsers, ["isOwner", "pointOfContact", "name"], ["desc", "desc", "asc"]);
	const userPermissions = state?.permissions?.my?.permissions?.permissions;
	const accountOwner = authorisedUsers?.find((user) => user?.status === "Owner");
	const profile = state.my?.profile

	return {
		...state.permissions,
		authorisedUsers: orderedUsers,
		jurisdiction: state.company?.settings?.jurisdiction,
		userPermissions,
		accountOwner,
		isDemo: state.company?.settings?.isDemo,
		isOwner: accountOwner?.userId === profile?.id,
	};
};

const mapDispatchToProps = (dispatch) => ({
	savePermissions: () => dispatch(ACTIONS.savePermissions()),
	getPermissions: () => dispatch(ACTIONS.getPermissions()),
	getMyPermissions: () => dispatch(ACTIONS.getMyPermissions()),
	openActionOnPermModal: (status) => dispatch(ACTIONS.openActionOnPermModal(status)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PermissionsTable);
